module.exports = __webpack_public_path__ + "img/ruleTable.e6063d96.png";